/**
 * Service option
 */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
/**
 * Material UI
 */
import { makeStyles } from '@mui/styles';
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Radio,
} from '@mui/material';
/**
 * Helpers
 */
import formatters from '../helpers/formatters';
import { wizardState } from '../redux/wizardSlice';

const useStyles = makeStyles(() => ({

  option: {
    borderRadius: 6,
    marginBottom: 2,
    boxSizing: 'border-box',
    border: '1px solid #DBDBDB',
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 20px 0px 20px',
  },
  optionError: {
    border: '1px solid red',
  },
  price: {
    fontWeight: 'bold',
    paddingTop: 10,
  },
}));

/**
 * Generic checkbox
 *
 * @param fieldName {string} : Field name
 * @param title {string} : Field label title
 * @param required {boolean}: Field is required
 * @param formik {object}: Formik instance
 * @returns {JSX.Element}
 */
function ServiceOption({
  formik,
  option,
}) {
  const classes = useStyles();
  const { validateForm } = useSelector(wizardState);
  const getControl = () => {
    if (option.type === 'checkboxes' || option.type === 'checkboxes-required') {
      return (
        <Checkbox
          name={option.id}
          onChange={formik.handleChange}
          value
          checked={formik.values[option.id] === true}
        />
      );
    }
    if (option.type === 'radio') {
      return (
        <Radio
          name={option.service}
          checked={formik.values[option.service] === option.id}
          value={option.id}
          onChange={formik.handleChange}
        />
      );
    }
    return (
      <Checkbox
        name={option.service}
        checked
        disabled
      />
    );
  };
  return (
    <FormGroup>
      <div
        className={clsx(
          classes.option,
          { [classes.optionError]: formik.errors[option.service] && validateForm },
          'service-option',
          'ga-service-option',
        )}
      >
        <FormControlLabel
          control={getControl()}
          label={option.name}
        />
        <div className={`${classes.price} ga-service-option-price`}>
          {`+${formatters.thousand(parseInt(option.value, 10), 0)}€`}
        </div>
      </div>
    </FormGroup>
  );
}

ServiceOption.propTypes = {
  formik: PropTypes.shape({
    initialValues: PropTypes.shape({}),
    values: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
    validateField: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    setTouched: PropTypes.func.isRequired,
    validateForm: PropTypes.func.isRequired,
    setErrors: PropTypes.func.isRequired,
    debounceTime: PropTypes.number,
    validateOnChange: PropTypes.bool,
    validateOnBlur: PropTypes.bool,
    dirty: PropTypes.bool,
  }).isRequired,
  option: PropTypes.shape({
    id: PropTypes.string,
    service: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};
ServiceOption.defaultProps = {
};
export default ServiceOption;
